const getList = ({ notification }: { notification: any }): NotificationType[] => notification.list;

export default { getList };
